import apiAxios from 'helpers/apiAxios';

// Draft Check: a draft vs the standard the user uploaded with it (backend Document::Compare).
const BASE = '/document/comparisons';

export const getComparison = (id) => apiAxios.get(`${BASE}/${id}`).then((r) => r.data);
// The marked-up file itself (Blob), for the online viewer.
export const getComparisonFile = (id) => apiAxios.get(`${BASE}/${id}/file`, { responseType: 'blob' }).then((r) => r.data);

// Commercial → Draft Check: a draft uploaded on its own (no Contract record).
const DRAFTS = '/document/draft_comparisons';

export const listDraftComparisons = () => apiAxios.get(DRAFTS).then((r) => r.data);
// Both files are uploaded: the standard and the draft to check.
export const createDraftComparison = ({ standardFile, file }) => {
  const form = new FormData();
  form.append('standard_file', standardFile);
  form.append('file', file);
  return apiAxios.post(DRAFTS, form, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
export const deleteDraftComparison = (id) => apiAxios.delete(`${DRAFTS}/${id}`);
